



/*
	
	CLASSES
	
*/


class ASGridGallery{
	
	constructor(images, container, opts) {
		this.className = opts?.className ?? 'as-grid-gallery';
		this.itemCount = opts?.itemCount ?? 4;
		this.maxRecent = opts?.maxRecent ?? 2;
		this.images = images.sort(() => 0.5 - Math.random());
		this.container=container;
		this.borders = {}
		//if images.length < itemCount*2 throw error
		this.init();
		
	}
	
	init(){
		//build grid html
		const grid=this.buildGrid();
		$(this.container).html(grid);

		//Init borders
		const images = this.getImageElements();
		images.each((_, img) => {	
		    const wrapperId = this.getImageWrapperId($(img));
		    if (img.complete) this.initBorder(wrapperId);
		    else {
		        $(img).on("load", () => {
		            this.initBorder(wrapperId);
		        }).on("error", () => {
		            console.warn(`Image failed to load: ${img.src}`);
		        });
		    }
		});
				
		//reset images list
	    const selectedImages = this.images.slice(0, this.itemCount);
	    const remainingImages = this.images.slice(this.itemCount); // Remaining images
	    this.images = [...remainingImages, ...selectedImages]; // Reorder array
		
		//run grid replacer
		this.gridReplacer = new GridImageReplacer(
			this.images,
			this.getGridSelectors(),
			{ maxRecent: this.maxRecent },
		    {			    
			    onReplace:(a,b)=>{
					const wrapperId = this.getImageWrapperId($('#'+a.id));
				    this.borders[wrapperId].triggerAnimation(550);
				}
		    }
		);		

	}
	
	getImageWrapperId(img){
		return img.parent().parent().attr("id");
	}
	
	getImageElements(){
		return $(`${this.container} img.grid-cell-image`);
	}
	
	getGridSelectors() {
		const images = this.getImageElements();
		return images.map((_, img) => '#'+$(img).attr("id")).get();
		
	}
	
	initBorder(id){	
	    // Check if the border is already initialized
	    if (!this.borders[id]) {
	        this.borders[id] = new GradientBorder(`#${id}`, {
	            thickness: 6,
	            speed: 0.18,
	            radius: 22,
	            startAngle: Math.random() * Math.PI * 2
	        });
	    }
	};
	
	buildGrid(){
	    const selectedImages = this.images.slice(0, this.itemCount);
	    const imagesHtml = selectedImages.map((src, index) => this.buildImage(src, index)).join("");
	    const gridHtml = `
	        <div class="cft-grid ${this.className}">
	            ${imagesHtml}
	        </div>
	    `;
	    return gridHtml;		
	}
	
	
	buildImage(src, index){
		const cellNumber = index + 1; // Cell numbers start from 1
		const html = `
			<div class="grid-item">
				<div id="cell${cellNumber}_wrap" class="border-container">
					<div>
						<img id="cell${cellNumber}" class="grid-cell-image" src="${src}" />
					</div>
				</div>
			</div>
		`;
		return html;		
	}
}

class Orb {
  constructor(radius, opts) {
	this._radius = radius;
    this.points = [];
    this.time=0;
    this.colorStops = opts.colorStops;
    this.scaleRange = opts.scaleRange;
    this.ovalFactor = opts.ovalFactor;
    this.pulseSpeed = opts.pulseSpeed;
  }
    
    
   get _ovalFactor() {
    return 1 + Math.sin(this.time) * this.ovalFactor; // 
  }

  init() {
    for (let i = 0; i < this.numPoints; i++) {
      let point = new Point(this.divisional * (i + 1), this);
      // point.acceleration = -1 + Math.random() * 2;
      this.push(point);
    }
  }
 
  render() {
	let canvas = this.canvas;
	let ctx = this.ctx;
	let position = this.position;
	let pointsArray = this.points;
	let radius = this.radius;
	let points = this.numPoints;
	let divisional = this.divisional;
	let center = this.center;

	ctx.clearRect(0, 0, canvas.width, canvas.height);
	
	this.time += this.pulseSpeed; // Increment time for smooth oscillation
	
	let baseScale = 1;
	let scaleRange = this.scaleRange

	// Smooth scaling using sine waves
	let scaleFactor = baseScale + Math.sin(this.time) * scaleRange; // Oscillates between 0.95 and 1.05
	let scaleFactor2 = baseScale + Math.cos(this.time) * scaleRange; // Oscillates between 0.95 and 1.05
	
	
	ctx.save();
	
	// Apply vertical scaling
	ctx.translate(center.x, center.y); // Move origin to center
	ctx.scale(scaleFactor, scaleFactor2);         // Stretch vertically
	ctx.translate(-center.x, -center.y); // Restore origin
	
	
	pointsArray[0].solveWith(pointsArray[points - 1], pointsArray[1]);
	
	let p0 = pointsArray[points - 1].position;
	let p1 = pointsArray[0].position;
	let _p2 = p1;
	
	ctx.beginPath();
	ctx.moveTo(center.x, center.y);
	ctx.moveTo((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);
	
	for (let i = 1; i < points; i++) {
	pointsArray[i].solveWith(
	  pointsArray[i - 1],
	  pointsArray[i + 1] || pointsArray[0]
	);
	
	let p2 = pointsArray[i].position;
	
	p2.x *= this._ovalFactor;
	p2.y *= 1/this._ovalFactor;
	var xc = (p1.x + p2.x) / 2;
	var yc = (p1.y + p2.y) / 2;
	ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);
	
	p1 = p2;
	}
	
	var xc = (p1.x + _p2.x) / 2;
	var yc = (p1.y + _p2.y) / 2;
	ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);
	
	ctx.closePath();
	
	// Create a radial gradient for the green blob with blurry edges
	let gradient = ctx.createRadialGradient(
		center.x,
		center.y,
		radius * 0,
		center.x,
		center.y,
		radius
	);

	for (let i=0; i<this.colorStops.length; i++){
		const stop = this.colorStops[i];
		gradient.addColorStop(stop[0], stop[1]);
	}
	// Apply the gradient and blur
	ctx.fillStyle = gradient;
	ctx.filter = "blur(10px)"; // Add a blur effect to the edges
	ctx.fill();
	
	// Reset the filter after drawing
	ctx.filter = "none";
	requestAnimationFrame(this.render.bind(this));
}

  push(item) {
    if (item instanceof Point) {
      this.points.push(item);
    }
  }

  set canvas(value) {
    if (
      value instanceof HTMLElement &&
      value.tagName.toLowerCase() === "canvas"
    ) {
      this._canvas = value;
      this.ctx = this._canvas.getContext("2d");
    }
  }
  get canvas() {
    return this._canvas;
  }

  set numPoints(value) {
    if (value > 2) {
      this._points = value;
    }
  }
  get numPoints() {
    return this._points || 32;
  }

  set radius(value) {
    if (value > 0) {
      this._radius = value;
    }
  }
  get radius() {
    return this._radius || 150;
  }

  set position(value) {
    if (typeof value == "object" && value.x && value.y) {
      this._position = value;
    }
  }
  get position() {
    return this._position || { x: 0.5, y: 0.5 };
  }

  get divisional() {
    return (Math.PI * 2) / this.numPoints;
  }

  get center() {
    return {
      x: this.canvas.width * this.position.x,
      y: this.canvas.height * this.position.y
    };
  }

  set running(value) {
    this._running = value === true;
  }
  get running() {
    return this.running !== false;
  }
}
class Point {
  constructor(azimuth, parent) {
    this.parent = parent;
    this.azimuth = Math.PI - azimuth;
    this._components = {
      x: Math.cos(this.azimuth),
      y: Math.sin(this.azimuth)
    };

    this.acceleration = -0.3 + Math.random() * 0.6;
  }

  solveWith(leftPoint, rightPoint) {
    this.acceleration =
      (-0.3 * this.radialEffect +
        (leftPoint.radialEffect - this.radialEffect) +
        (rightPoint.radialEffect - this.radialEffect)) *
        this.elasticity -
      this.speed * this.friction;
  }

  set acceleration(value) {
    if (typeof value == "number") {
      this._acceleration = value;
      this.speed += this._acceleration * 1.4;
    }
  }
  get acceleration() {
    return this._acceleration || 0;
  }

  set speed(value) {
    if (typeof value == "number") {
      this._speed = value;
      this.radialEffect += this._speed * 1.5;
    }
  }
  get speed() {
    return this._speed || 0;
  }

  set radialEffect(value) {
    if (typeof value == "number") {
      this._radialEffect = value;
    }
  }
  get radialEffect() {
    return this._radialEffect || 0;
  }

  get position() {
    return {
      x:
        this.parent.center.x +
        this.components.x * (this.parent.radius + this.radialEffect),
      y:
        this.parent.center.y +
        this.components.y * (this.parent.radius + this.radialEffect)
    };
  }

  get components() {
    return this._components;
  }

  set elasticity(value) {
    if (typeof value === "number") {
      this._elasticity = value;
    }
  }
  get elasticity() {
    return this._elasticity || 0.0001;
  }
  set friction(value) {
    if (typeof value === "number") {
      this._friction = value;
    }
  }
  get friction() {
    return this._friction || 0.0085;
  }
}
class ASOrb {
	constructor(container, radius=150, _opts={}){
		
		const opts = {
			colorStops:[
				[0, "rgba(55, 140, 199, .9)"], 
				
				[0.3, "rgba(55, 140, 199, .9)"],
				
				[0.75, "rgba(16, 206, 144, 0.4)"],
				[1, "rgba(16, 206, 144, 0)"],
		    ],
		    rippleStrength:20,
		    rippleInterval:20,
		    scaleRange:0.002,
		    ovalFactor:0.02,
		    pulseSpeed:0.01,
		    ..._opts
		}
		
		const orb = new Orb(radius, opts);
		const wh = radius*3;	
			
		const canvas = document.createElement("canvas");
		canvas.setAttribute("touch-action", "none");
		container.appendChild(canvas);	
		
		let resize = function () {
			canvas.width = wh;
			canvas.height = wh;
		};
		
		window.addEventListener("resize", resize);
		resize();
		
	
		let rippleEffect = function () {
			let randomPointIndex = Math.floor(Math.random() * orb.points.length);
			let randomStrength = Math.random() *  opts.rippleStrength;
			orb.points[randomPointIndex].acceleration = (randomStrength / 100) * (Math.random() > 0.5 ? 1 : -1);
		};

		orb.canvas = canvas;
		orb.init();
		orb.render();
			
		setInterval(rippleEffect, opts.rippleInterval);	
	}
}

class GridImageReplacer {
	
	constructor(imageArray, gridSelectors, opts = {}, events = {}) {
		// Inputs
		this.imageArray     = Array.from(new Set(imageArray)); // ensure unique pool
		this.gridSelectors  = gridSelectors;
		this.events         = events ?? {};
	
		// Options
		this.duration       = opts.duration ?? 500;
		this.delay          = opts.delay ?? 2000;
		this.maxRecent      = Math.min(gridSelectors.length, opts.maxRecent ?? 3);   // recent slots memory
		this.imageCooldownMs= opts.imageCooldownMs ?? 0;                             // avoid reusing a src too soon
	
		// Internals
		this.usedIndices    = [];         // recent slots picked
		this.currentBySlot  = [];         // current src per slot
		this.usage          = new Map();  // src → stats
		this._timer         = null;
	
		// Initialize usage + slot occupancy from the DOM
		this._initUsageTracking();
	
		// Start the loop
		this.start();
	}


	/* ------------------------------
	* Lifecycle
	* ------------------------------ */
	start() {
		const interval = this.delay + this.duration + 10;
		if (this._timer) clearInterval(this._timer);
		this._timer = setInterval(() => this.replaceRandomImage(), interval);
	}

	stop() {
		if (this._timer) {
			clearInterval(this._timer);
			this._timer = null;
		}
	}
	
	/* ------------------------------
	* DOM helpers
	* ------------------------------ */
	
	getImage(selector) {return document.querySelector(selector);}

	crossFadeImage(selector, newSrc, duration) {
    	const img = this.getImage(selector);
		if (!img) return;

		const parent = img.parentElement;
		
		// Single onReplace hook (avoid double-calling)
		if (this.events.onReplace) this.events.onReplace(img, newSrc);
		
		if (window.getComputedStyle(parent).position === 'static') {
			parent.style.position = 'relative';
		}

		const overlayImg = document.createElement('img');
		overlayImg.src = newSrc;
		overlayImg.style.position = 'absolute';
		overlayImg.style.top = '0';
		overlayImg.style.left = '0';
		overlayImg.style.width = '100%';
		overlayImg.style.height = '100%';
		overlayImg.style.opacity = '0';
		overlayImg.style.transition = `opacity ${duration}ms ease-in-out`;
		overlayImg.style.pointerEvents = 'none';
		overlayImg.style.zIndex = '5';

		parent.appendChild(overlayImg);

		overlayImg.onload = () => {
			overlayImg.style.opacity = '1';
			setTimeout(() => {
				img.src = newSrc;
				setTimeout(() => {
					parent.removeChild(overlayImg);
					if (this.events.afterReplace) this.events.afterReplace(img, newSrc);
				}, 500);
			}, duration + 5);
		};
		
		overlayImg.onerror = () => {
			console.error(`Failed to load image from ${newSrc}`);
			parent.removeChild(overlayImg);
		};
	}

	/* ------------------------------
	* Random slot (respect recent-memory)
	* ------------------------------ */
	
	getRandomIndex() {
		const all = this.gridSelectors.map((_, i) => i);

		const recentSet = new Set(this.usedIndices);
		let available = all.filter(i => !recentSet.has(i));
		if (available.length === 0) available = all; 

		const pick = available[Math.floor(Math.random() * available.length)];

		this.usedIndices.push(pick);
		if (this.usedIndices.length > this.maxRecent) {
			this.usedIndices = this.usedIndices.slice(-this.maxRecent);
  		}

  		return pick;
	}


	/* ------------------------------
	* Usage tracking
	* ------------------------------ */
	_ensureUsage(src) {
		if (!this.usage.has(src)) {
			this.usage.set(src, {
				shownCount: 0,
				replacedIntoCount: 0,
				replacedOutCount: 0,
				lastShown: 0,
				lastReplacedOut: 0,
				slotsHistory: [] // { slot, when, action: 'in'|'out' }
			});
		}
		return this.usage.get(src);
	}

	_initUsageTracking() {
		
    	for (const src of this.imageArray) this._ensureUsage(src);

		// Read current DOM occupancy
		this.currentBySlot = this.gridSelectors.map((selector, slot) => {
			const img = this.getImage(selector);
			const src = img?.src || null;
			if (src) {
				const u = this._ensureUsage(src);
				u.shownCount += 1;
				u.replacedIntoCount += 1;
				u.lastShown = Date.now();
				u.slotsHistory.push({ slot, when: Date.now(), action: 'in' });
			}
			return src;
		});
	}

  	getUsageReport({ sortBy = 'shownCount', desc = true } = {}) {
		const rows = [];
		for (const [src, u] of this.usage.entries()) {
			rows.push({
				src,
				shownCount: u.shownCount,
				replacedIntoCount: u.replacedIntoCount,
				replacedOutCount: u.replacedOutCount,
				lastShown: u.lastShown,
				lastReplacedOut: u.lastReplacedOut
			});
		}
	    rows.sort((a, b) => {
			const da = a[sortBy] ?? 0;
			const db = b[sortBy] ?? 0;
			return desc ? (db - da) : (da - db);
	    });
    	return rows;
	}
	
	logUsageSummary(topN = null) {
		const rows = this.getUsageReport({ sortBy: 'shownCount', desc: true });
		const out = topN ? rows.slice(0, topN) : rows;
		console.table(out.map(r => ({
			used: r.shownCount,
			into: r.replacedIntoCount,
			out:  r.replacedOutCount,
			lastShown: new Date(r.lastShown).toLocaleTimeString(),
			src:  r.src
		})));
	}

	/* ------------------------------
	* Candidate selection
	* ------------------------------ */
	_pickNextSrc({ cooldownMs = 0 } = {}) {
		const currentSet = new Set(
			this.gridSelectors.map(sel => this.getImage(sel)?.src).filter(Boolean)
		);
	

		const candidates = this.imageArray.filter(src => !currentSet.has(src));
		if (candidates.length === 0) return null;
	
		const now = Date.now();

		//cool down ensures nothing gets picked twice in a certain timeframe
		const cooled = cooldownMs > 0
		? candidates.filter(src => (now - (this._ensureUsage(src).lastShown || 0)) >= cooldownMs)
		: candidates.slice();
	
		const pool = cooled.length ? cooled : candidates; 
	
		let minCount = Infinity;
		for (const src of pool) {
			const u = this._ensureUsage(src);
			if (u.shownCount < minCount) minCount = u.shownCount;
		}
		
		const leastShown = pool.filter(src => this._ensureUsage(src).shownCount === minCount);
	
		const idx = Math.floor(Math.random() * leastShown.length);
		return leastShown[idx] || null;
	}
  


	/* ------------------------------
	* Replace logic (with accounting)
	* ------------------------------ */
	replaceRandomImage() {
		if (!this.imageArray.length) {
			console.warn('Image array is empty. Nothing to replace.');
			return;
		}
	
		const chosenSrc = this._pickNextSrc({ cooldownMs: this.imageCooldownMs });
		if (!chosenSrc) {
			console.warn('No candidate available to replace (pool may match the grid).');
			return;
		}
	
		// pick a random slot (respects recent memory)
		const slot = this.getRandomIndex();
		const selector = this.gridSelectors[slot];
	
		const imgEl  = this.getImage(selector);
		const oldSrc = imgEl?.src || this.currentBySlot[slot] || null;
	
		// Kick off the visual swap
		this.crossFadeImage(selector, chosenSrc, this.duration);
	
		// Update usage stats immediately
		const now = Date.now();
	
		// outgoing accounting
		if (oldSrc) {
			const outU = this._ensureUsage(oldSrc);
			outU.replacedOutCount += 1;
			outU.lastReplacedOut = now;
			outU.slotsHistory.push({ slot, when: now, action: 'out' });
		}
		
		// incoming accounting
		const inU = this._ensureUsage(chosenSrc);
		inU.shownCount += 1;
		inU.replacedIntoCount += 1;
		inU.lastShown = now;
		inU.slotsHistory.push({ slot, when: now, action: 'in' });
	
		// record current occupancy
		this.currentBySlot[slot] = chosenSrc;
	
		// Rotate the pool without creating duplicates:
		const poolIdx = this.imageArray.indexOf(chosenSrc);
		if (poolIdx !== -1) this.imageArray.splice(poolIdx, 1);
		this.imageArray.push(chosenSrc);
		//this.logUsageSummary(10);
		//console.log(`[replaceRandomImage] slot ${slot}: ${oldSrc || '(empty)'} → ${chosenSrc}`);
	}
}

class GradientBorder {
	
	constructor(selector, options = {}) {
		
		this.elements = document.querySelectorAll(selector);
		this.options = {
			animate: options.animate || false, // Enable or disable continuous animation
			speed: options.speed || 0.01, // Speed of animation
			thickness: options.thickness || 10,
			gradient: options.gradient || [[0,"#10CE90"], [.8,"#123654"]],
			radius: options.radius || 20, // Outer radius
		    startAngle: options.startAngle || 0, // Starting rotation angle in radians

		};
		this.borders = [];
		this.manualAnimationActive = false;
		this.init();
	}

	init() {
		this.elements.forEach((element) => {		
	
			const borderCanvas = document.createElement("canvas");
			borderCanvas.style.width = "100%";
			borderCanvas.style.height = "100%";
			
			const borderCanvasContainer = document.createElement("div");
			borderCanvasContainer.className='gradient-border';
			borderCanvasContainer.style.position = "absolute";
			borderCanvasContainer.style.top = 0;
			borderCanvasContainer.style.left = 0;
			borderCanvasContainer.style.right = 0;
			borderCanvasContainer.style.bottom = 0;
			borderCanvasContainer.style.pointerEvents = "none";
			
			borderCanvasContainer.appendChild(borderCanvas);
			
			//element.style.position = "relative";
			element.appendChild(borderCanvasContainer);
	
			this.borders.push({
				element,
				canvas: borderCanvas,
				context: borderCanvas.getContext("2d"),
			    angle: this.options.startAngle,

			});

			this.resizeCanvas(borderCanvas, element);
			if (!this.options.animate) this.drawBorder(borderCanvas.getContext("2d"), borderCanvas, this.options.startAngle); 
			else this.animate();				
		});


		window.addEventListener("resize", () => {
			this.borders.forEach(({ canvas, element }) => {
				this.resizeCanvas(canvas, element);
				if (!this.options.animate) {
					this.drawBorder(canvas.getContext("2d"), canvas, this.options.startAngle); // Static border
				}
			});
		});
	}

	resizeCanvas(canvas, element) {
		const rect = element.getBoundingClientRect();
		const scale = window.devicePixelRatio || 1;
		
		canvas.width = rect.width * scale;
		canvas.height = rect.height * scale;
		
		canvas.style.width = `${rect.width}px`;
		canvas.style.height = `${rect.height}px`;
		
		const context = canvas.getContext("2d");
		context.scale(scale, scale);
	}

	drawBorder(context, canvas, angle) {
		const rect = canvas.getBoundingClientRect();
		const width = rect.width;
		const height = rect.height;
		
		const radius = this.options.radius;
		const thickness = this.options.thickness;
	
		const gradient = context.createLinearGradient(
			width / 2 + Math.cos(angle) * width * .55,
			height / 2 + Math.sin(angle) * height * .55,
			width / 2 - Math.cos(angle) * width * .55,
			height / 2 - Math.sin(angle) * height * .55
		);
		
		this.options.gradient.forEach(c=>{
			gradient.addColorStop(c[0], c[1]);			
		})

		context.clearRect(0, 0, width, height);
	
		context.strokeStyle = gradient;
		context.lineWidth = thickness;
		context.lineJoin = "round";
	
		context.beginPath();
	
		context.moveTo(thickness / 2 + radius, thickness / 2);
		context.lineTo(width - thickness / 2 - radius, thickness / 2);
		context.arcTo(
			width - thickness / 2,
			thickness / 2,
			width - thickness / 2,
			thickness / 2 + radius,
			radius
		);
	
		context.lineTo(width - thickness / 2, height - thickness / 2 - radius);
		context.arcTo(
			width - thickness / 2,
			height - thickness / 2,
			width - thickness / 2 - radius,
			height - thickness / 2,
			radius
		);
	
		context.lineTo(thickness / 2 + radius, height - thickness / 2);
		context.arcTo(
			thickness / 2,
			height - thickness / 2,
			thickness / 2,
			height - thickness / 2 - radius,
			radius
		);
	
		context.lineTo(thickness / 2, thickness / 2 + radius);
		context.arcTo(
			thickness / 2,
			thickness / 2,
			thickness / 2 + radius,
			thickness / 2,
			radius
		);
	
		context.closePath();
		context.stroke();
	}

	animate() {
	    if (this.options.animate || this.manualAnimationActive) {
	        this.borders.forEach((border) => {
	            const normalizedAngle = border.angle / (Math.PI * 2); // Normalize angle between 0 and 1
	            border.angle += this.options.speed;
	            if (border.angle > Math.PI * 2) border.angle -= Math.PI * 2;
	            this.drawBorder(border.context, border.canvas, border.angle);
	        });
	        requestAnimationFrame(() => this.animate());
	    }
	}

	animationEasing(elapsedTime, duration) {
	    const t = Math.min(elapsedTime / duration, 1); // Normalize elapsedTime to [0, 1]
	    return Math.cos((t * Math.PI) / 2); // Smooth deceleration starting at 1
	}
	
	triggerAnimation(duration = 500) {
		if (this.manualAnimationActive) return; // Avoid overlapping manual animations
			this.manualAnimationActive = true;
	
		const startTime = performance.now();
		const animateForDuration = () => {
			const currentTime = performance.now();
			const elapsedTime = currentTime - startTime;
			if (elapsedTime < duration) 
			{
				this.borders.forEach((border) => {
				    const easingFactor = this.animationEasing(elapsedTime, duration); // Normalize angle to [0, 1]
					border.angle += this.options.speed*easingFactor;
					if (border.angle > Math.PI * 2) border.angle -= Math.PI * 2;
					this.drawBorder(border.context, border.canvas, border.angle);
				});
				requestAnimationFrame(animateForDuration);
			} 
			else this.manualAnimationActive = false; // Stop the manual animation
		};
		animateForDuration();
	}
}




$(document).ready( function() {


	// mobile menu nav handling
	$('.menu-toggle').on('click', function(){
		$(this).toggleClass('closer');
		$('body').toggleClass('menu-open');
		$('.nav-primary').toggleClass('active');
	});
	
	$('.caret').on('click', function(){
		 $(this).toggleClass('rotate');
		 $(this).siblings('.sub-menu').slideToggle();
	 })

	
	/* Fixed header */	 
	let isFixed = false;
	$(window).on('scroll', function () {
		if ($(window).scrollTop() > 100) {
			if (!isFixed) {
				$('header.banner').addClass('fixed');
				isFixed = true;
			}
		} 
		else if (isFixed) {
			$('header.banner').removeClass('fixed');
			isFixed = false;
		}
	});

	// sticky footer
	var minH = $(window).height() - ( $('header.banner').height() + $('footer').outerHeight());
	$('.wrap').css({minHeight:minH});

	// banner slider
	if( $('.slider') ) {
		$('.slider').slick({
			fade: true,
			infinite:true,
			arrows: false,
			dots: false,
			autoplay: true,
			autoplaySpeed: 5000
		});
	}
	
	
	const track = document.getElementById('logoTrack');
	if (!track) return;
	
	const groups = track.querySelectorAll('.marquee-group');
	const first  = groups[0];
	const clone  = track.querySelector('.marquee-group.clone');
	

	if (clone && clone.children.length === 0 && first) {
		clone.innerHTML = first.innerHTML;
		clone.setAttribute('aria-hidden', 'true');
	}

	const pxPerSecond = 20; 
	const resize = () => {
	    requestAnimationFrame(() => {
			const fullWidth = track.scrollWidth;   // both groups together
			const oneCycle  = fullWidth / 2;       // one group width
			const duration  = oneCycle / pxPerSecond; // seconds
			track.style.animationDuration = `${Math.max(10, duration)}s`;
    	});
  	};

	// First run + on resize
	resize();
	window.addEventListener('resize', resize, { passive: true });

	
});

$(window).on('load', ()=>{
	/* Drop down border */
	const dropDownBorder = new GradientBorder(".sub-menu", {
		animate: false,
		thickness: 5,
		speed:0.04,
		radius: 15,
		startAngle:1.5
	});
	
	if($(".api-box-wrap").length){
		window.apiBorder = new GradientBorder(".api-box-wrap", {
			animate: false,
			thickness: 5,
			speed:0.3,
			radius: 15,	
			gradient: [
				[0,"#10CE90"], 
				[.92, "#195b63"],
				[.97,"#123654"]
			]		
		});
	}
	
	const videoBorder = new GradientBorder(".video-container", {
		animate: false,
		thickness: 5,
		radius: 15,
	});
	
	const screenshotBorder = new GradientBorder(".screenshot-wrap", {
		animate: false,
		thickness: 5,
		radius: 15,
		startAngle: 4.7
	});
	const gradientBorder = new GradientBorder('.gradient-border-wrap', {
		animate: false,
		thickness: 5,
		radius: 18,
		startAngle: 1.2
	});
	
	/*
	document.querySelectorAll("#menu-primary-navigation > li.dropdown").forEach((element) => {
		element.addEventListener("mouseenter", () => {
			//dropDownBorder.triggerAnimation(1000); // Trigger animation for 0.5s
		});
	});
	*/
})

const handleScroll = () => {
    $('.site-section').each(function () {
        const el = $(this);

        if (isInViewport(el) && !el.hasClass('animated')) {
	        el.addClass('animated');
            
            const animationAttr = el.attr('animation');

            if (animationAttr) {
                const functionName = `animate_${animationAttr}`;
                if (typeof window[functionName] === 'function') {
                    window[functionName](el);
                }
            }
        }
    });
};

let lastScrollTop = 0;

const isInViewport = (el) => {
    const elementTop = el.offset().top;
    const elementBottom = elementTop + el.outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    const downOffset = $(window).height() * 0.3;
    const upOffset = $(window).height() * 0.5;

    const scrollingDown = viewportTop > lastScrollTop;

    const adjustedViewportTop = viewportTop + (scrollingDown ? downOffset : upOffset);
    const adjustedViewportBottom = viewportBottom - (scrollingDown ? downOffset : upOffset);

    lastScrollTop = viewportTop;

    return (elementBottom >= adjustedViewportTop && elementTop <= adjustedViewportBottom);
};



//Screenshot slider
$(document).ready(function () {
	
	//Config	
	const fadeSpeed = 500;
	const displayTime = 3000;

	
    const images = $(".screenshot-slider img");
    const totalImages = images.length;
    let currentIndex = 0;

    images.eq(currentIndex).addClass("active").css("z-index", 2);
    images.css("transition", `opacity ${fadeSpeed}ms ease-in-out`);

    setInterval(()=>{
	    const currentImage = images.eq(currentIndex);
        const nextIndex = (currentIndex + 1) % totalImages;
        const nextImage = images.eq(nextIndex);

        nextImage.css("z-index", 3).addClass("active");

        setTimeout(() => {
            currentImage.removeClass("active").css("z-index", 1);
            nextImage.css("z-index", 2);
            currentIndex = nextIndex;
        }, fadeSpeed+100);
	}, displayTime);
	
});
	
	
function throttle(callback, limit) {
    let wait = false;
    return function () {
        if (!wait) {
            callback.call();
            wait = true;
            setTimeout(() => {
                wait = false;
            }, limit);
        }
    };
}

// Services animations
const throttledHandleScroll = throttle(handleScroll, 100);
$(window).on('load', function(){
	setTimeout(handleScroll, 100);
	$(window).on('scroll', throttledHandleScroll);
		
	$('body').addClass('loaded');

	if($('body').hasClass('home')){
		$(".slide-caption .orb").get().forEach((el) => {
			const orb = new ASOrb(el, 100);
		});
		const dspsOrb = new ASOrb($(".dsps-orb").get()[0], 250);
	}
	
	
	if($('body').hasClass('page-template-template-partners')){
		const partnerstOrb = new ASOrb($(".partners-orb").get()[0], 250, {
			colorStops: [
				[0, "rgba(59, 199, 181, 1)"],       
				[0.5, "rgba(59, 199, 181, 0.5)"],   
				[1, "rgba(59, 199, 181, 0)"]    
			],
			scaleRange: 0.0010,
			rippleInterval: 30,
			rippleStrength: 10,
			ovalFactor: 0.02,
			pulseSpeed: 0.005
		});
	}
	if($('body').hasClass('page-template-template-services')){
		const catManagementOrb = new ASOrb($(".cat-management-orb").get()[0], 380, {
			colorStops: [
				[0, "rgba(255, 99, 132, 1)"],     
				[0.5, "rgba(255, 99, 132, 0.5)"],  
				[1, "rgba(255, 99, 132, 0)"]        
			],
			scaleRange: 0.0027,
			rippleInterval: 30,
			rippleStrength: 20,
			ovalFactor: 0.02,
			pulseSpeed: 0.01
		});
		const dspsServiesOrb = new ASOrb($(".services-dsps-orb").get()[0], 250);
		const aorb = new ASOrb($(".analytics-orb1").get()[0], 280);
		
		const aorb2Conf = {
			colorStops:[
				[0, "rgba(255, 230, 100, 1)"],
				[0.55, "rgba(200, 100, 50, 0.6)"],
				[0.9, "rgba(150, 50, 25, 0.8)"],
				[1, "rgba(100, 30, 15, 0)"],
			],
		    scaleRange:0.0005,
			rippleInterval:50, 
			rippleStrength:25, 
			ovalFactor:0.05,
			pulseSpeed:0.004
		}
		const aorb2 = new ASOrb($(".analytics-orb2").get()[0], 200, aorb2Conf);
		
		const aorb3Conf = {
			colorStops:[
			    [0, "rgba(102, 51, 153, .8)"], // Muted purple (amethyst) at the start with 80% opacity
			    [0.3, "rgba(102, 51, 153, .8)"], // Maintain muted purple for the first 30%
			    [0.75, "rgba(147, 112, 219, 0.4)"], // Transition to medium purple with reduced opacity
			    [1, "rgba(147, 112, 219, 0)"], // Fade to transparent medium purple
			],
		    scaleRange:0.0001,
			rippleInterval:40, 
			rippleStrength:15, 
			ovalFactor:0.025,
			pulseSpeed:0.01
		}
		const aorb3 = new ASOrb($(".analytics-orb3").get()[0], 200, aorb3Conf);
	}
	
});

// Services animations
async function typeUrl() {
	const url = $('.url-box').data('url');
	const preElement = document.getElementById('url-text');
	let index = 0;
	
	while (index < url.length) {
		preElement.textContent += url[index];
		index++;
		const randomNum = Math.floor(Math.random() * (70 - 30 + 1)) + 30;
		await delay(randomNum);
	}
}
	 
async function typeJSON() {
	const jsonData = $('.json-box').data('json');
	const formattedJson = JSON.stringify(jsonData, null, 2);
	const preElement = document.getElementById('formatted-json');
	let index = 0;
	
	while (index < formattedJson.length) {
		preElement.textContent += formattedJson[index];
		hljs.highlightElement(preElement);
		index++;
		await delay(.5);
	}
}

const delay = (ms) =>  new Promise(resolve => setTimeout(resolve, ms));



const animate_api = async ()=> {
  $('.api-box-wrap').addClass('animated');

  await delay(1000);
  typeUrl();

  await delay(4200);
  window.apiBorder.triggerAnimation(2000);

  await delay(2200);
  typeJSON();
}




// Services Distribution Grid
if($('.services-grid-gallery').length){
	const srcs = JSON.parse($('.services-grid-gallery').attr("data-srcs"));
	if(srcs.length) new ASGridGallery(srcs, '.services-grid-gallery');	
}

// About us grid
if($('.about-grid-gallery').length){
	const srcs = JSON.parse($('.about-grid-gallery').attr("data-srcs"));
	if(srcs.length) new ASGridGallery(srcs, '.about-grid-gallery', {itemCount:9});
}